<header>
  <a routerLink="/home">
    <img src="assets/logo_te.svg" title="TotalEnergies" alt="TotalEnergies" class="logo me-4 pointer" />
  </a>
  <div class="header-right">
    <div class="header-top">
      <div class="me-auto header-title">
        <div class="app-name me-3">
          {{'general.app_name' | translate}}
        </div>
      </div>
      @if (user()) {
      <div class="d-flex">
        <div>
          <a routerLink="/home">
            <div class="icon-text">
              <mat-icon color="primary">home</mat-icon>
              <span>{{'general.navigation.home' | translate}}</span>
            </div>
          </a>
        </div>

        <div>
          <div class="icon-text">
            <mat-icon color="primary">account_circle</mat-icon>
            <span>{{user()?.first_name | uppercasefirstletter}} {{user()?.last_name | uppercase}} - {{('enums.roles.' + user()?.role?.code) | translate}}</span>
          </div>
        </div>

        <div>
          <a href="mailto:snow.secops.run_glb_tgs@totalenergies.com">
            <div class="icon-text">
              <mat-icon color="warn" class="support-icon">report_problem</mat-icon>
              <span>{{'general.navigation.support' | translate}}</span>
            </div>
          </a>
        </div>

        @if(user()?.isSuperAdmin()) {
        <div>
          <a routerLink="/administration">
            <div class="icon-text">
              <mat-icon color="primary">settings</mat-icon>
              <span>{{'general.navigation.administration'| translate}}</span>
            </div>
          </a>
        </div>
        }


        <div class="lang-picker">
          <div class="icon-text pointer" (click)="language_picker_open=!language_picker_open" appClickOutside (clickOutside)="language_picker_open=false">
            <mat-icon color="primary">language</mat-icon>
            <span>{{('general.languages.'+translate.getDefaultLang())|translate}}</span>
            <mat-icon color="primary" class="ms-0">keyboard_arrow_down</mat-icon>
          </div>
          <div class="language-list" [hidden]="!language_picker_open">
            <ul>
              @for (lang of langages; track $index) {
              <li (click)="selectLanguage(lang)">
                <div class="icon-text d-flex justify-content-between">
                  @if(translate.getDefaultLang()===lang){
                  <mat-icon color="primary">check</mat-icon>
                  }@else {
                  <mat-icon color="primary"></mat-icon>
                  }
                  <span>{{('general.languages.'+lang)|translate}}</span>
                </div>
              </li>
              }
            </ul>
          </div>
        </div>

      </div>
      }
    </div>

  </div>
</header>